import React from 'react';
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import TabelsRows from './TabelsRows';
import { customStylesForTesting, hoverTooltip } from '../../../Components/helper';

const openCol = (option) => {
  return option?.colour?.length > 0 ? `${option?.colour?.name}` : '';
};

const openBom = (option) => {
  return option?.bomComponent ? `${option?.bomComponent?.referenceCode}` : '';
};

const openDesc = (option) => {
  return option.description ? `${option.description}` : '';
};

function Tabels({
  handleSelectAll,
  isSelectAll,
  allTests,
  onSortColumn,
  sortTable,
  iconsChange,
  onSelectCheckBox,
  currentIndex,
  savedEdit,
  type,
  selectedIdArray,
  handleChange,
  desc,
  handleSelectType,
  addInfo,
  actionButtons,
  handleEdit,
  bomOptions,
  supplierOptions,
  handleSelectBom,
  handleSelectColour,
  handleSelectSupplier,
  selectedSupplier,
  forEditId,
  selectedBom,
  colourOptions,
  selectedColour,
  hideBom,
  isLoading,
  showNewRow,
  forNewOptions,
  handleSelectedOption,
  cancleBtn,
  handleExpand,
  newArrayWithData,
  copyItem,
  expandAllData,
  indexes,
  parentIndexes,
  count,
  setForEditId,
  fromBom,
  TestingDeleteAccess,
  testPrice,
  code,
}) {
  const ProductTestingData = useSelector((redState) => redState);
  const { UserDetails, BOMConfigDetails } = ProductTestingData;
  const { isSupplierLoggedIn } = UserDetails;
  const { isProductArchived } = BOMConfigDetails;
  const { t } = useTranslation('common');

  const noDataCalled = () => {
    if (!showNewRow) {
      return !hideBom ? (
        <tr>
          <td className=" text-center" colSpan="12">
            <h6>{t('DEVLOPMENT_ORDER.TESTING.PRODUCT_TABLES.NO_TEST_REQ_FOUND')}</h6>
          </td>
        </tr>
      ) : (
        <tr>
          <td className=" text-center" colSpan="12">
            <h6>{t('DEVLOPMENT_ORDER.TESTING.PRODUCT_TABLES.NO_TESTING_ATTRIBUTE_FOUND')}</h6>
          </td>
        </tr>
      );
    }
  };

  const tab = (testItem, testIndex) => {
    return (
      <TabelsRows
        item={testItem}
        i={testIndex}
        onSelectCheckBox={onSelectCheckBox}
        selectedIdArray={selectedIdArray}
        currentIndex={currentIndex}
        savedEdit={savedEdit}
        handleChange={handleChange}
        type={type}
        desc={desc}
        handleSelectType={handleSelectType}
        addInfo={addInfo}
        testPrice={testPrice}
        actionButtons={actionButtons}
        handleEdit={handleEdit}
        bomOptions={bomOptions}
        supplierOptions={supplierOptions}
        handleSelectBom={handleSelectBom}
        handleSelectColour={handleSelectColour}
        handleSelectSupplier={handleSelectSupplier}
        selectedBom={selectedBom}
        selectedSupplier={selectedSupplier}
        selectedColour={selectedColour}
        forEditId={forEditId}
        colourOptions={colourOptions}
        hideBom={hideBom}
        expandGrandTotalChild={handleExpand}
        allDatas={newArrayWithData}
        copyItem={copyItem}
        parentIndexes={parentIndexes}
        array={newArrayWithData}
        allTestData={allTests}
        setForEditId={setForEditId}
        fromBom={fromBom}
        TestingDeleteAccess={TestingDeleteAccess}
        code={code}
      />
    );
  };

  const testAttri = () => {
    return !isLoading && newArrayWithData && !isEmpty(newArrayWithData)
      ? newArrayWithData.map((testItem, testIndex) => {
          return tab(testItem, testIndex);
        })
      : noDataCalled();
  };

  const modalTables = () => {
    return hideBom ? 'hideProductTesting' : forProductTesting();
  };

  const forProductTesting = () => {
    return isSupplierLoggedIn ? 'supplierProductTesting' : 'ProductTesting';
  };

  const openSupps = (option) => {
    return option?.supplier ? `${option?.supplier?.name}, ` : '';
  };

  const openBracket = (option) => {
    return option?.supplier || option?.bomComponent || option?.colour?.length > 0 ? ' (' : '';
  };

  const CloseBracket = (option) => {
    return option?.supplier || option?.bomComponent || option?.colour?.length > 0 ? ' )' : '';
  };

  const expands = () => {
    return indexes.length === count ? (
      <button className="btn-up-down" onClick={() => expandAllData()} type="button" aria-label="close">
        <span className="icon-new-down-arrow-icon icon-inverse" />
      </button>
    ) : (
      <button className="btn-up-down" onClick={() => expandAllData()} type="button" aria-label="open">
        <span className="icon-new-down-arrow-icon " />
      </button>
    );
  };

  const optionalChange = (option) => {
    return (
      <div className="d-flex" key={option._id}>
        <div className="list-text">
          {option?.code
            ? hoverTooltip(
                `${option?.code}${openBracket(option)}${openSupps(option)}${openBom(option)}${openCol(option)}${CloseBracket(option)}-${openDesc(option)}`,
              )
            : ''}
        </div>
      </div>
    );
  };

  return (
    <table
      className={
        hideBom
          ? 'table common-custom-table mb-0 mt-16 layout-fixed testing-attribute-table'
          : 'table common-custom-table mb-0 mt-16 layout-fixed testing-attribute-table '
      }
      id={showNewRow ? 'testingAttribute' : modalTables()}
    >
      <thead>
        <tr>
          {!isSupplierLoggedIn && !isProductArchived && (
            <th className="w-50px">
              <div className="common-checkbox no-label checkbox-center">
                <input type="checkbox" onChange={handleSelectAll} name="check_all" id="check_all" checked={isSelectAll} disabled={isEmpty(allTests)} />
                <label htmlFor="check_all" className="chklabel" />
              </div>
            </th>
          )}
          {count !== 0 ? <th className="w-50px w-xs-40px">{expands()}</th> : <th className="w-50px w-xs-40px" />}
          <th
            onClick={() => {
              onSortColumn('code');
            }}
            className="w-230px first-fix-col"
          >
            <span className="cursor-pointer d-flex">
              {t('DEVLOPMENT_ORDER.TESTING.PRODUCT_TABLES.TESTING_CODE')}
              {sortTable.propertyName === 'code' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}{' '}
            </span>
          </th>
          <th
            onClick={() => {
              onSortColumn('description');
            }}
            className="w-230px"
          >
            <span className="cursor-pointer d-flex">
              {t('DEVLOPMENT_ORDER.TESTING.PRODUCT_TABLES.DESCRIPTION')}
              {sortTable.propertyName === 'description' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}{' '}
            </span>
          </th>
          <th
            onClick={() => {
              onSortColumn('type');
            }}
            className="w-200px"
          >
            <span className="cursor-pointer d-flex">
              {t('DEVLOPMENT_ORDER.TESTING.PRODUCT_TABLES.TEST_TYPE')}
              {sortTable.propertyName === 'type' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}
            </span>
          </th>
          <th
            onClick={() => {
              onSortColumn('minPassRate');
            }}
            className="w-200px"
          >
            <span className="cursor-pointer d-flex">
              {t('DEVLOPMENT_ORDER.TESTING.PRODUCT_TABLES.MINUM_PASS_RATE')}
              {sortTable.propertyName === 'minPassRate' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}
            </span>
          </th>
          <th
            onClick={() => {
              onSortColumn('testReport');
            }}
            className="w-200px"
          >
            <span className="cursor-pointer d-flex">
              {t('DEVLOPMENT_ORDER.TESTING.PRODUCT_TABLES.TEST_REPORTS')}
              {sortTable.propertyName === 'testReport' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}
            </span>
          </th>
          <th onClick={() => onSortColumn('supplier')} className="w-200px">
            <span className="cursor-pointer d-flex">
              {t('DEVLOPMENT_ORDER.TESTING.PRODUCT_TABLES.SUPPLIER')}
              {sortTable.propertyName === 'supplier' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}
            </span>
          </th>
          {!hideBom && (
            <th
              onClick={() => {
                onSortColumn('bomComponent');
              }}
              className="w-200px"
            >
              <span className="cursor-pointer d-flex">
                {t('DEVLOPMENT_ORDER.TESTING.PRODUCT_TABLES.BOM_COMPONENET')}
                {sortTable.sortPropertyName === 'bomComponent' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}
              </span>
            </th>
          )}
          <th
            onClick={() => {
              onSortColumn('colour');
            }}
            className="w-200px"
          >
            <span className="cursor-pointer d-flex">
              {t('DEVLOPMENT_ORDER.TESTING.PRODUCT_TABLES.COLOR_REF')}
              {sortTable.propertyName === 'colour' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}
            </span>
          </th>
          <th
            onClick={() => {
              onSortColumn('additionalInformation');
            }}
            className="w-250px"
          >
            <span className="cursor-pointer d-flex">
              {t('DEVLOPMENT_ORDER.TESTING.PRODUCT_TABLES.ADDITIONAL_INFO')}
              {sortTable.propertyName === 'additionalInformation' ? (
                <>{iconsChange()}</>
              ) : (
                <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />
              )}
            </span>
          </th>
          <th
            onClick={() => {
              onSortColumn('testPrice');
            }}
            className="w-250px"
          >
            <span className="cursor-pointer d-flex">
              {t('DEVLOPMENT_ORDER.TESTING.PRODUCT_TABLES.TEST_PRICE')}
              {sortTable.propertyName === 'testPrice' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}
            </span>
          </th>
          <th
            onClick={() => {
              onSortColumn('result');
            }}
            className="w-100px last-fix-col"
          >
            <span className=" d-flex">
              {t('DEVLOPMENT_ORDER.TESTING.PRODUCT_TABLES.RESULT_STATUS')}
              {sortTable.propertyName === 'result' ? <>{iconsChange()}</> : <i className="icon-Table-Up font-weight-heavy text-black f-14 ml-1" />}
            </span>
          </th>
          <th className="w-150px" />
        </tr>
      </thead>
      <tbody className="border_bottom_z">
        {showNewRow ? (
          <>
            <tr key={0}>
              <td colSpan={3} style={{ zIndex: 2 }} className="first-fix-col ">
                <div className="custom-react-select">
                  <Select
                    name="selectedEntery"
                    maxMenuHeight={132}
                    menuPosition="fixed"
                    options={forNewOptions}
                    getOptionLabel={(option) => optionalChange(option)}
                    getOptionValue={(option) => `${option._id}`}
                    styles={customStylesForTesting}
                    onChange={(e) => handleSelectedOption(e)}
                    placeholder={t('DEVLOPMENT_ORDER.TESTING.PRODUCT_TABLES.TEST_TYPES')}
                  />
                </div>
              </td>
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td className="last-fix-col" />
              <td className="text-right">{cancleBtn()}</td>
            </tr>
            {testAttri()}
          </>
        ) : (
          testAttri()
        )}
      </tbody>
    </table>
  );
}

export default Tabels;
